export default "__VITE_ASSET__CpUamjGD__"